var React = require('react');

function SpinnerMd (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"ring","fill":"none","strokeWidth":"10%","strokeLinecap":"butt","cx":"50%","cy":"50%","r":"45%","key":0}),React.createElement("circle",{"className":"path","fill":"none","strokeWidth":"10%","strokeLinecap":"butt","cx":"50%","cy":"50%","r":"45%","key":1})]);
}

SpinnerMd.displayName = "SpinnerMd";

SpinnerMd.defaultProps = {"className":"spinner-md","width":"100px","height":"100px","viewBox":"0 0 101 101"};

module.exports = SpinnerMd;

SpinnerMd.default = SpinnerMd;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/spinner-md.svg